<template>
  <div>
    <basic-container>
      <div>
        <el-form
          ref="form"
          :model="serviceItemForm"
        >
          <!-- <el-form-item
            label="是否顶级服务"
            label-position="top"
          >
            <el-radio
              v-model="isTop"
              label="YES"
              @change="clearTable"
              disabled
            >是</el-radio>
            <el-radio
              v-model="isTop"
              @change="clearTable"
              label="NO"
              disabled
            >否</el-radio>
          </el-form-item> -->
          <el-form-item label="服务类目名称">
            <div
              v-if='isTop == "NO"'
              style="display: flex;width:300px;"
            >
              <el-select
                v-model="serviceItemForm.superiorId"
                placeholder="请选择服务类目名称"
                disabled
                width="300"
              >
                <el-option
                  v-for="item in superiorIds"
                  :key="item.id"
                  :label="item.name"
                  :value='item.id'
                ></el-option>
              </el-select>
            </div>
            <div
              v-if='isTop == "YES"'
              style="display: flex;width:300px;"
            >
              <el-input
                v-model="serviceItemForm.name"
                clearable
                placeholder='请输入顶级服务类目名称'
              ></el-input>
            </div>
          </el-form-item>
          <el-form-item
            label="服务项目名称"
            v-if="isTop == 'NO'"
          >
            <div style="display: flex;width:300px;">
              <el-input
                v-model="serviceItemForm.name"
                placeholder='请输入服务项目名称'
              ></el-input>
            </div>
          </el-form-item>
          <el-form-item
            label="服务预约配置"
            v-if="isTop == 'NO'"
          >
            <el-table
              :data="tableData"
              :span-method="objectSpanMethod"
              border
              style="width: 100%; margin-top: 20px"
            >

              <el-table-column
                prop="clientType"
                label="预约渠道"
              >
                <template slot-scope="scope">
                  <el-select
                    v-model="scope.row.clientType"
                    placeholder="请选择服务类目名称"
                    width="300"
                  >
                    <el-option
                      v-for="item in clientTypes"
                      :key="item.value"
                      :label="item.label"
                      :value='item.value'
                    ></el-option>
                  </el-select>
                </template>

              </el-table-column>

              <!-- <el-table-column
                prop="agentId"
                label="关联服务商"
                min-width="100"
              >
                <template slot-scope="scope">
                  <el-select
                    v-model="scope.row.agentId"
                    placeholder="请选择关联服务商"
                    width="300"
                  >
                    <el-option
                      v-for="item in agentIds"
                      :key="item.id"
                      :label="item.company"
                      :value='item.id'
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column> -->
              <!-- <el-table-column
                prop="auditor"
                label="审核方"
                min-width="100"
              >
                <template slot-scope="scope">
                  <el-select
                    v-model="scope.row.auditor"
                    placeholder="请选择服务类目名称"
                    width="300"
                  >
                    <el-option
                      v-for="item in auditors"
                      :key="item.value"
                      :label="item.label"
                      :value='item.value'
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column> -->
              <el-table-column
                prop="payer"
                label="支付方"
                min-width="100"
              >
                <template slot-scope="scope">
                  <el-select
                    v-model="scope.row.payer"
                    placeholder="请选择服务类目名称"
                    width="300"
                  >
                    <el-option
                      v-for="item in payers"
                      :key="item.value"
                      :label="item.label"
                      :value='item.value'
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column>

              <el-table-column
                prop="isVisit"
                label="上门费"
                width="150"
              >
                <template slot-scope="scope">
                  <el-radio
                    v-model="scope.row.isVisit"
                    label="YES"
                  >
                    有
                  </el-radio>
                  <el-radio
                    v-model="scope.row.isVisit"
                    label="NO"
                  >
                    无
                  </el-radio>
                </template>
              </el-table-column>
              <el-table-column
                prop="name"
                label="上门费明细"
                min-width="120"
              >
                <template slot-scope="scope">
                  <div style="display: flex;flex-flow:column nowrap;justify-content:space-around">
                    <el-input
                      type="input"
                      name="points"
                      size="small"
                      v-if="scope.row.isVisit =='YES'&& scope.row.agentId == '0'"
                      v-model="scope.row.points"
                      :value="scope.row.points"
                      placeholder="请输入积分值"
                    ></el-input>
                    <el-input
                      type="input"
                      name="amount"
                      size="small"
                      v-if="scope.row.isVisit =='YES'&& scope.row.agentId == '0'"
                      v-model="scope.row.amount"
                      :value="scope.row.amount"
                      placeholder="积分足额上门费金额"
                    ></el-input>
                    <el-input
                      type="input"
                      name="standbyAmount"
                      size="small"
                      v-if="scope.row.isVisit =='YES'&& scope.row.agentId == '0'"
                      v-model="scope.row.standbyAmount"
                      :value="scope.row.standbyAmount"
                      placeholder="积分不足上门费金额"
                    ></el-input>
                    <el-input
                      type="input"
                      name="amount"
                      size="small"
                      v-if="scope.row.isVisit =='YES'&& scope.row.agentId !== '0'"
                      v-model="scope.row.amount"
                      :value="scope.row.amount"
                      placeholder="上门费金额"
                    ></el-input>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="area"
                min-width="120"
                label="服务区域"
              >
                <template slot-scope="scope">
                  <div>
                    <div>
                      <el-select
                        clearable
                        v-model="scope.row.provinces"
                        size="small"
                        @change="chooseProvince(scope.row.provinces,scope)"
                        placeholder="请选择省份"
                        value-key="id"
                      >
                        <el-option
                          v-for="item in provinces"
                          :key="item.id"
                          :label="item.name"
                          :value="item"
                        ></el-option>
                      </el-select>
                    </div>
                    <div>
                      <el-select
                        clearable
                        v-model="scope.row.citys"
                        size="small"
                        @change="chooseCity(scope.row.citys,scope)"
                        value-key="id"
                        placeholder="请选择城市"
                      >
                        <el-option
                          v-for="item in scope.row.citysList"
                          :key="item.id"
                          :label="item.name"
                          :value="item"
                        ></el-option>
                      </el-select>
                    </div>
                    <div>
                      <el-select
                        clearable
                        v-model="scope.row.areas"
                        size="small"
                        @change="chooseArea(scope.row.areas,scope)"
                        value-key="id"
                        placeholder="请选择地区"
                      >
                        <el-option
                          v-for="item in scope.row.areasList"
                          :key="item.id"
                          :label="item.name"
                          :value="item"
                        ></el-option>
                      </el-select>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                label="操作"
                width="120"
              >

                <template slot-scope="scope">
                  <el-button
                    type="danger"
                    icon="el-icon-close"
                    size="small"
                    @click="handleSteppingDelete(scope.$index, scope.row)"
                  >删除
                  </el-button>
                </template>
              </el-table-column>

              <el-table-column
                align="center"
                label="配置"
                width="150"
              >
                <template slot-scope="scope">
                  <el-button
                    type="warning"
                    icon="el-icon-check"
                    size="small"
                    @click="handleAddRows(scope.$index, scope.row)"
                  >增加一行</el-button>
                </template>
              </el-table-column>
              <template slot="empty">
                <el-button
                  type="warning"
                  icon="el-icon-check"
                  size="small"
                  style="margin: 20px 0"
                  @click="handleAddRows()"
                >增加一行</el-button>
              </template>
            </el-table>
          </el-form-item>
        </el-form>
        <div style='width:100%;display:flex;flex-flow:row nowrap;justify-content: center;margin-top:20px'>
          <el-button
            type="primary"
            size="big"
            @click="submit"
          >确定修改</el-button>
        </div>
      </div>
    </basic-container>
  </div>
</template>

<script>
import { DIC } from "@/const/dic";
import { resolveUrlPath } from "@/util/util";
import {
  findProject,
  findProjectList,
  editProject,
  findProvince,
  findCitys,
  findAreas,
  findAgentId
} from "@/api/work/serviceItem";
import { findUserId } from "@/api/salesCloud/company";

export default {
  data() {
    return {
      serviceItemForm: { name: "" },
      isTop: "YES",
      isPas: false,
      agentIds: [],
      areas: [],
      citys: [],
      provinces: [],
      superiorIds: [],
      clientTypes: DIC.SERVICEITEM_TYPE,
      auditors: DIC.SERVICEITEM_AUDITOR,
      payers: DIC.SERVICEITEM_PAYER,
      players: DIC.SERVICEITEM_PAYER,
      tableData: [],
      userId: "",
      submitData: []
    };
  },
  created() {
    findUserId().then(res => {
      console.log(res);
      let data = JSON.parse(res.data);
      this.userId = data.id;
    });
    let params = {};
    params.id = this.$router.currentRoute.query.id;
    findProjectList(params).then(res => {
      let data = JSON.parse(res.data);
      console.log(data);
      this.serviceItemForm.superiorId = data.rows[0].superiorId;
      if (data.rows[0].superiorId) {
        this.isTop = "NO";
        this.serviceItemForm.name = data.rows[0].name;
      } else {
        this.isTop = "YES";
        this.serviceItemForm.name = this.$router.currentRoute.query.aname;
      }
      findAgentId(this.userId).then(res => {
        console.log(res);
        let localdata = [];
        for (let i of data.rows[0].configs) {
          console.log(i.agentId, res.data);
          i.provinces = {};
          i.provinces.id = i.province;
          i.provinces.name = i.provinceName;

          i.citysList = [];

          i.citys = {};
          i.citys.id = i.city;
          i.citys.name = i.cityName;

          i.areasList = [];
          if (i.pca) {
            if (i.pca.cities) {
              i.citysList = i.pca.cities;
            }
            if (i.pca.areas) {
              i.areasList = i.pca.areas;
            }
          }
          i.areas = {};
          i.areas.id = i.area;
          i.areas.name = i.areaName;
          if (i.agentId == res.data) {
            localdata.push(i);
          } else {
            this.submitData.push(i);
          }
          // i.areas.id = i.area;
          // i.areas.name = i.areaName;
          //  i.areasList = {};
          // i.areasList.id = i.area;
          // i.areasList.name = i.areaName;
          // i.areasList = {};
          // i.areasList.id = i.area;
          // i.areasList.name = i.areaName;
        }

        console.log(data.rows[0].configs);
        console.log(localdata);
        // this.tableData = data.rows[0].configs;
        this.tableData = localdata;
      });
    });
    findProject().then(res => {
      let data = JSON.parse(res.data);
      this.superiorIds = data;
    });
    // findAllSuperiorDepartment().then(res => {
    //   let data = JSON.parse(res.data);
    //   console.log(data);

    //   this.agentIds = data;
    //   this.agentIds.push({ company: "社区", id: "0" });
    // });
    findProvince().then(res => {
      // let data = JSON.parse(res.data);
      this.provinces = res.data;
      this.currentProvince = "";
      this.currentCity = "";
      this.currentArea = "";
    });
  },
  methods: {
    chooseProvince(provinces, scope) {
      console.log(provinces);
      console.log(scope);
      findCitys(provinces.id).then(res => {
        //   console.log(res);
        scope.row.citysList = res.data;
        scope.row.citys = {};
        scope.row.areas = {};
        //   console.log(scope);
      });
    },
    chooseCity(citys, scope) {
      findAreas(citys.id).then(res => {
        scope.row.areasList = res.data;
        scope.row.areas = {};
      });
    },
    chooseArea(areas, scope) {
      console.log(areas);
    },
    clearTable() {
      this.serviceItemForm = {};
      this.tableData = [];
    },
    submit() {
      let item = {
        close: true,
        label: "编辑服务项目",
        value: "/work/serviceItem/edit"
      };
      let params = {};
      // console.log(this.serviceItemForm);
      params = this.serviceItemForm;
      params.isTop = this.isTop;
      params.id = this.$router.currentRoute.query.id;
      for (let i = 0; i < this.tableData.length; i++) {
        this.tableData[i].auditor = "AGENT";
        // console.log(this.tableData[i]);
        // console.log(this.tableData[i].provinces.id);
        if (this.tableData[i].provinces.id != undefined) {
          this.tableData[i].province = this.tableData[i].provinces.id;
          this.tableData[i].provinceName = this.tableData[i].provinces.name;
        } else {
          this.tableData[i].province = "";
          this.tableData[i].provinceName = "";
        }
        // console.log(this.tableData[i].citys.id);
        if (this.tableData[i].citys.id != undefined) {
          this.tableData[i].city = this.tableData[i].citys.id;
          this.tableData[i].cityName = this.tableData[i].citys.name;
        } else {
          this.tableData[i].city = "";
          this.tableData[i].cityName = "";
        }
        // console.log(this.tableData[i].areas.id);
        if (this.tableData[i].areas.id != undefined) {
          this.tableData[i].areaName = this.tableData[i].areas.name;
          this.tableData[i].area = this.tableData[i].areas.id;
        } else {
          this.tableData[i].area = "";
          this.tableData[i].areaName = "";
        }
        if (!this.tableData[i].clientType) {
          this.$message({
            showClose: true,
            message: "请选择预约渠道",
            type: "error"
          });
          return;
        }
        if (!this.tableData[i].payer) {
          this.$message({
            showClose: true,
            message: "请选择支付方",
            type: "error"
          });
          return;
        }
        // if (!this.tableData[i].auditor) {
        //   this.$message({
        //     showClose: true,
        //     message: "请选择审核方",
        //     type: "error"
        //   });
        //   return;
        // }
        if (!this.tableData[i].isVisit) {
          this.$message({
            showClose: true,
            message: "请选择有无上门费",
            type: "error"
          });
          return;
        } else {
          if (
            this.tableData[i].agentId == "0" &&
            this.tableData[i].isVisit == "YES"
          ) {
            if (
              !this.tableData[i].points ||
              !this.tableData[i].amount ||
              !this.tableData[i].standbyAmount
            ) {
              this.$message({
                showClose: true,
                message: "请填写上门费明细",
                type: "error"
              });
              return;
            }
          } else if (
            this.tableData[i].agentId != "0" &&
            this.tableData[i].isVisit == "YES"
          ) {
            if (!this.tableData[i].amount) {
              this.$message({
                showClose: true,
                message: "请填写上门费明细",
                type: "error"
              });
              return;
            }
          } else if (this.tableData[i].isVisit == "NO") {
            this.tableData[i].amount = 0;
            // console.log(this.tableData[i]);
          }
        }
        this.submitData.push(this.tableData[i]);
      }
      // console.log(this.tableData);
      console.log(this.tableData);
      console.log(this.submitData);

      params.configs = this.submitData;
      // console.log(params);
      editProject(params).then(res => {
        if (res.code == "200") {
          this.$message({
            showClose: true,
            message: "修改成功",
            type: "success"
          });
          if (!this.isPas) {
            this.$store.commit("DEL_TAG", item);
            let obj = {
              value: "/work/serviceItem",
              label: "服务项目管理"
            };
            this.$router.push({
              path: resolveUrlPath(obj.value, obj.label),
              query: obj.query
            });
            this.isPas = true;
          }
        } else {
          if (!this.isPas) {
            this.$message({
              showClose: true,
              message: res.message,
              type: "error"
            });
            this.isPas = true;
            setTimeout(() => {
              this.submitData = [];
              this.isPas = false;
            }, 1000);
          }
        }
      });
    },
    handleSteppingDelete(index, row) {
      //   this.propertiesList.splice(index, 1);

      this.tableData.splice(index, 1);
    },
    handleAddRows(index, row) {
      let list = {
        citysList: [],
        areasList: [],
        citys: {},
        areas: {},
        provinces: {},
        deleteFlag: "NO"
      };
      this.tableData.push(list);
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 6) {
        if (rowIndex % 100 === 0) {
          return {
            rowspan: 100,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    }
  }
};
</script>

<style>
</style>